import './CheckBox.css';

import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

const CheckBox = ({ children, disabled, onChange, className }) => {
  CheckBox.propTypes = {
    children: PropTypes.node,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    className: PropTypes.string
  };

  return (
    <Checkbox
      className={className ? `${className} checkbox-container` : 'checkbox-container'}
      disabled={disabled || false}
      onChange={onChange}>
      {children}
    </Checkbox>
  );
};

export default CheckBox;
